import React from "react";
import PrimaryButton from "./PrimaryButton";
import { Calendar } from "lucide-react";

export default function ScheduleMeetingButton() {
  return (
    <PrimaryButton
      icon={Calendar}
      onClick={() =>
        window.open("https://forms.gle/gnLeRHSLrd87DwSf7", "_blank")
      }
    >
      Agendar uma conversa
    </PrimaryButton>
  );
}
